import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      "home": "Home",
      "products": "Products",
      "services": "Services",
      "about": "About Us",
      "contact": "Contact Us",
      "heroTitle": "Ascent Corporation Co., Ltd.",
      "heroSubtitle": "Leading importer and distributor of high-quality medical equipment with comprehensive maintenance services",
      "heroButton": "View Our Products",
      "aboutUsTitle": "About Us",
      "aboutUsDesc": "Ascent Corporation Co., Ltd. is committed to providing the best medical equipment services with an expert and experienced team to make your healthcare more efficient and safer.",
      "visionTitle": "Our Vision",
      "visionDesc": "We focus on being a leading importer and distributor of medical equipment, developing quality products that meet customer needs, and building trust through innovative technology and expert, efficient services.",
      "recommendedProducts": "Recommended Products",
      "recommended": "Recommended",
      "viewAllProducts": "View All Products",
      "ourServices": "Our Services",
      "maintenanceService": "Medical Equipment Maintenance",
      "maintenanceDesc": "Providing maintenance and inspection services by experts to ensure efficiency and safety.",
      "technicalConsultation": "Technical Consultation",
      "technicalDesc": "Advising on usage and selecting appropriate equipment for your hospital or clinic.",
      "distribution": "Medical Equipment Distribution",
      "distributionDesc": "Importing and distributing high-quality medical equipment at reasonable prices.",
      "certification": "Certification",
      "certSubtitle": "We meet international standards certified by global organizations",
      "newsAndActivities": "News & Activities",
      "noNews": "No news available at the moment",
      "trustedClients": "Trusted by Leading Clients",
      "trustedClientsDesc": "Trusted by leading hospitals and clinics nationwide",
      "contactUs": "Contact Us",
      "contactDesc": "Contact us for more information or consultation",
      "address": "214/201 Moo 5, Mae Hia Subdistrict,\nMueang Chiang Mai District, Chiang Mai 50100",
      "taxId": "Tax ID: 0345563000173",
      "phone": "Phone:",
      "email": "Email:",
      "businessHours": "Business Hours: Mon - Sat 08:00 - 17:00",
      "followUs": "Follow Us",
      "loading": "Loading data...",
      "clickToView": "Click to view full size",
      "noData": "No certification data available",
      "loadingNews": "Loading news...",
      "readMore": "Read More",
      "viewDetail": "View Details",
      "whatYouGet": "What you will get",
      "serviceDetail1": "Services by expert engineering teams",
      "serviceDetail2": "ISO International Standards",
      "serviceDetail3": "Quality guarantee for repairs and parts",
      "serviceDetail4": "Consultation throughout usage",
      "allProducts": "All Products",
      "categories": "Categories",
      "searchPlaceholder": "Search categories...",
      "ourProductsTitle": "Our Products",
        "ourProductsSubtitle": "High-quality imported medical equipment and more",
        "searchProductPlaceholder": "Search for products...",
        "allCategories": "All",
        "loadingProducts": "Loading products...",
        "noProductsFound": "No products found",
        "interestedOrConsult": "Interested in a product or need consultation?",
        "teamReadyToHelp": "Our team is ready to advise and assist you.",
        "callToInquire": "Call to Inquire",
        "sendEmail": "Send Email",
        "productDetailsTitle": "Product Details",
        "specialOrderChannels": "Exclusive Order Channels",
        "servicesPageTitle": "Our Services",
"servicesTagline": "Comprehensive, Professional, Reliable",
"servicesIntro": "Ascent Corporation Co., Ltd. is committed to providing comprehensive medical equipment services, including procurement, maintenance, and professional consultation, to ensure your healthcare facility operates efficiently and safely.",
"mainServicesTitle": "Our Main Services",

"service1Title": "Medical Equipment Procurement",
"service1Desc": "We source high-quality, international standard medical equipment and recommend models that fit your budget and needs.",
"service1Feat1": "Imported from leading manufacturers",
"service1Feat2": "FDA & CE Standards",
"service1Feat3": "Quality Guarantee",

"service2Title": "Medical Equipment Maintenance",
"service2Desc": "Regular inspection, repair, and maintenance services to extend equipment lifespan and reduce risk of damage.",
"service2Feat1": "Annual Inspection",
"service2Feat2": "24/7 Urgent Repair",
"service2Feat3": "Professional Technician Team",

"service3Title": "Equipment Usage Training",
"service3Desc": "Training medical staff to use equipment correctly, safely, and with maximum efficiency.",
"service3Feat1": "Expert Trainers",
"service3Feat2": "Hands-on Practice",
"service3Feat3": "Post-training Certificate",

"service4Title": "Medical Technology Consultation",
"service4Desc": "Technical advice and appropriate technology selection to help you make cost-effective purchasing and usage decisions.",
"service4Feat1": "Needs Analysis",
"service4Feat2": "New Technology Recommendations",
"service4Feat3": "ROI Calculation",

"whyChooseUsTitle": "Why Choose Us",
"benefit1Title": "International Standards",
"benefit1Desc": "Equipment certified to international standards.",
"benefit2Title": "Fast Service",
"benefit2Desc": "Responding to all needs promptly.",
"benefit3Title": "After-Sales Service",
"benefit3Desc": "Continuous care and support after sales.",

"serviceProcessTitle": "Service Process",
"process1Title": "Consultation",
"process1Desc": "Analyzing and listening closely to your needs.",
"process2Title": "Recommendation",
"process2Desc": "Offering appropriate solutions at cost-effective prices.",
"process3Title": "Installation & Training",
"process3Desc": "Detailed equipment installation and usage training.",
"process4Title": "After-Sales Care",
"process4Desc": "Continuous maintenance and problem-solving services.",

"readyToServeTitle": "Ready to Serve You Today",
"readyToServeDesc": "Free Consultation! Our expert team is ready to provide the right advice for you.",
"contactUsNow": "Contact Us Now",
"viewProductsBtn": "View Products",
"aboutPageTitle": "About Us",
"aboutTagline": "Leader in International Standard Medical Equipment",
"companyFullName": "Ascent Corporation Co., Ltd.",
"companyIntroDesc": "We are a leading importer and distributor of modern, international standard medical equipment. We select high-quality products from around the world to meet the needs of hospitals, clinics, and general users, with a commitment to enhancing patients' quality of life through the best medical technology.",

"visionSectionTitle": "Our Vision",
"visionSectionDesc": "To be the largest medical equipment importer and distributor in the lower Northeast region, developing quality products that meet customer needs, and building trust through modern innovation.",
"missionSectionTitle": "Our Mission",
"missionSectionDesc": "To provide services with an expert team, supporting healthcare facilities in patient care with standard equipment and fast after-sales service.",

"coreValuesTitle": "Core Values",
"value1Title": "Highest Quality",
"value1Desc": "All products are certified to international standards, ensuring efficiency and reliability.",
"value2Title": "Excellent Service",
"value2Desc": "Our professional team is ready to provide consultation and close after-sales care.",
"value3Title": "Long Experience",
"value3Desc": "Extensive expertise accumulated in the medical equipment business.",
"value4Title": "Clear Goals",
"value4Desc": "Committed to being the leader in medical equipment in the lower Northeast region.",

"productsAndServicesTitle": "Products & Services",
"device1Title": "Vital Signs Monitors",
"device1Desc": "Blood pressure monitors, fingertip pulse oximeters, and high-precision ECG monitors.",
"device2Title": "Patient Beds & Recovery",
"device2Desc": "Electric beds, adjustable beds, wheelchairs, and comprehensive patient assistance equipment.",
"device3Title": "Basic Equipment & Medical Supplies",
"device3Desc": "Digital thermometers, clinical thermometers, and first aid kits for home and hospital use.",

"aboutCtaTitle": "Ready to Care for You with Quality Equipment",
"aboutCtaDesc": "Consult our expert team immediately.",
"contactUsBtn": "Contact Us",
"viewAllProductsBtn": "View All Products",
"contactErrorAlert": "An error occurred while sending the message: ",
"phoneTitle": "Phone",
"mainLineLabel": "Main Line",
"emailTitle": "Email",
"addressTitle": "Address",
"companyAddressFull": "214/201 Moo 5, Mae Hia Subdistrict, Mueang Chiang Mai District, Chiang Mai 50100",
"businessHoursTitle": "Business Hours",
"mondayToSaturday": "Mon - Sat",
"businessHoursValue": "08:00 AM - 05:00 PM",
"sundayLabel": "Sunday",
"closedLabel": "Closed",

"contactUsTitle": "Contact Us",
"contactUsTagline": "We are ready to serve and answer all your questions",
"contactChannelsTitle": "Contact Channels",
"contactChannelsDesc": "If you have any questions or need consultation about medical equipment, contact us immediately through the channels below.",
"followUsOnSocial": "Follow Us on Social Media",

"messageSentSuccess": "Message Sent Successfully!",
"messageSentThanks": "Thank you for contacting us. We will get back to you as soon as possible.",

"formNameLabel": "Full Name *",
"formNamePlaceholder": "Enter your name",
"formPhoneLabel": "Phone Number *",
"formPhonePlaceholder": "e.g., 099-888-7777",
"formEmailLabel": "Email *",
"formEmailPlaceholder": "e.g., user123@gmail.com",
"formSubjectLabel": "Subject *",
"formSubjectOption1": "Select Subject",
"formSubjectOption2": "Product Inquiry",
"formSubjectOption3": "Service Inquiry",
"formSubjectOption4": "Request Support",
"formSubjectOption5": "Other",
"formMessageLabel": "Message *",
"formMessagePlaceholder": "Write your message here...",
"formSendingBtn": "Sending...",
"formSubmitBtn": "Send Message",

"mapAndLocationTitle": "Map & Location",
"mapTitle": "Ascent Corporation Co., Ltd. Map"
    }
  },
  th: {
    translation: {
      "home": "หน้าแรก",
      "products": "สินค้า",
      "services": "บริการ",
      "about": "เกี่ยวกับเรา",
      "contact": "ติดต่อเรา",
      "heroTitle": "ASCENT CORPORATION CO., LTD.",
      "heroSubtitle": "ผู้นำเข้าและจัดจำหน่ายเครื่องมือแพทย์คุณภาพสูง พร้อมบริการซ่อมบำรุงครบวงจร",
      "heroButton": "ดูผลิตภัณฑ์ของเรา",
      "aboutUsTitle": "เกี่ยวกับเรา",
      "aboutUsDesc": "บริษัท แอสเซนท์ คอร์ปอเรชั่น จำกัด มุ่งมั่นที่จะให้บริการที่ดีที่สุดในด้านเครื่องมือแพทย์ ด้วยทีมงานที่มีความเชี่ยวชาญและประสบการณ์ เพื่อช่วยให้การดูแลสุขภาพของคุณมีประสิทธิภาพและปลอดภัยยิ่งขึ้น",
      "visionTitle": "วิสัยทัศน์",
      "visionDesc": "มุ่งเน้นเป็นผู้นำเข้าและจำหน่ายเครื่องมือแพทย์ พัฒนาสินค้าให้มีคุณภาพตอบโจทย์กับลูกค้าและกลุ่มเป้าหมาย สร้างความเชื่อมั่นให้ลูกค้าด้วยนวัตกรรมและเทคโนโลยีที่ทันสมัย พร้อมให้บริการที่มีคุณภาพด้วยทีมงานที่มีความเชี่ยวชาญ รอบรู้ และมีประสิทธิภาพสูง",
      "recommendedProducts": "สินค้าแนะนำ",
      "recommended": "แนะนำ",
      "viewAllProducts": "ดูสินค้าทั้งหมด",
      "ourServices": "บริการของเรา",
      "maintenanceService": "บริการซ่อมบำรุงเครื่องมือแพทย์",
      "maintenanceDesc": "ให้บริการซ่อมบำรุงและตรวจสอบอุปกรณ์การแพทย์โดยผู้เชี่ยวชาญ เพื่อให้ใช้งานได้อย่างมีประสิทธิภาพและปลอดภัย",
      "technicalConsultation": "ให้คำปรึกษาด้านเทคนิค",
      "technicalDesc": "แนะนำการใช้งานและเลือกอุปกรณ์ที่เหมาะสมกับสถานพยาบาล โรงพยาบาล หรือคลินิกของคุณ",
      "distribution": "จัดจำหน่ายอุปกรณ์การแพทย์",
      "distributionDesc": "นำเข้าและจัดจำหน่ายอุปกรณ์การแพทย์คุณภาพสูงจากต่างประเทศในราคาที่เหมาะสม",
      "certification": "certificate",
      "certSubtitle": "เรามีมาตรฐานสากลที่ได้รับการรับรองจากองค์กรระดับโลก",
      "newsAndActivities": "ข่าวสารและกิจกรรม",
      "noNews": "ยังไม่มีข่าวสารในขณะนี้",
      "trustedClients": "ลูกค้าที่ไว้วางใจเรา",
      "trustedClientsDesc": "ได้รับความไว้วางใจจากโรงพยาบาลและคลินิกชั้นนำทั่วประเทศ",
      "contactUs": "ติดต่อเรา",
      "contactDesc": "ติดต่อสอบถามข้อมูลเพิ่มเติมหรือขอคำปรึกษาได้ที่นี่",
      "address": "เลขที่ 214/201 หมู่ที่ 5 ตําบลแม่เหียะ อําเภอเมืองเชียงใหม่\nจังหวัดเชียงใหม่ 50100",
      "taxId": "เลขประจำตัวผู้เสียภาษีอากร : 0345563000173",
      "phone": "โทรศัพท์:",
      "email": "อีเมล:",
      "businessHours": "เวลาทำการ: จันทร์ - เสาร์ 08:00 - 17:00 น.",
      "followUs": "ติดตามเรา",
      "loading": "กำลังโหลดข้อมูล...",
      "clickToView": "คลิกเพื่อดูขนาดใหญ่",
      "noData": "ไม่มีข้อมูลใบรับรอง",
      "loadingNews": "กำลังโหลดข่าวสาร...",
      "readMore": "อ่านเพิ่มเติม",
      "viewDetail": "ดูรายละเอียด",
      "whatYouGet": "สิ่งที่คุณจะได้รับ",
      "serviceDetail1": "บริการโดยทีมงานวิศวกรผู้เชี่ยวชาญ",
      "serviceDetail2": "มาตรฐานสากล ISO",
      "serviceDetail3": "การรับประกันคุณภาพงานซ่อมและอะไหล่",
      "serviceDetail4": "ให้คำปรึกษาตลอดการใช้งาน",
      "allProducts": "ดูสินค้าทั้งหมด",
      "categories": "หมวดหมู่สินค้า",
      "searchPlaceholder": "ค้นหาหมวดหมู่...",
      "ourProductsTitle": "สินค้าของเรา",
    "ourProductsSubtitle": "เครื่องมือแพทย์คุณภาพสูงจากต่างประเทศ และอื่นๆ",
    "searchProductPlaceholder": "ค้นหาสินค้า...",
    "allCategories": "ทั้งหมด",
    "loadingProducts": "กำลังโหลดข้อมูลสินค้า...",
    "noProductsFound": "ไม่พบสินค้าที่ค้นหา",
    "interestedOrConsult": "สนใจสินค้าหรือต้องการคำปรึกษา?",
    "teamReadyToHelp": "ทีมงานของเราพร้อมให้คำแนะนำและช่วยเหลือคุณ",
    "callToInquire": "โทรสอบถาม",
    "sendEmail": "ส่งอีเมล",
    "productDetailsTitle": "รายละเอียดผลิตภัณฑ์",
    "specialOrderChannels": "ช่องทางการสั่งซื้อพิเศษ",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'th',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;